import { render, staticRenderFns } from "./SpacesMilestones.vue?vue&type=template&id=1b66fd65&scoped=true&"
import script from "./SpacesMilestones.vue?vue&type=script&lang=js&"
export * from "./SpacesMilestones.vue?vue&type=script&lang=js&"
import style0 from "./SpacesMilestones.vue?vue&type=style&index=0&id=1b66fd65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66fd65",
  null
  
)

export default component.exports